"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAccessStatusDefaultStrategy = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var models_1 = require("../models");
var requestRoute = "access/status";
var execute = function (request) {
    console.log("Executing default check access status strategy");
    return requestAccessStatus(request);
};
var requestAccessStatus = function (request) {
    var requestParams = [models_1.AuthSuiteSdkClientRequestParams.LogoSchema, models_1.AuthSuiteSdkClientRequestParams.ResourceGroup];
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: requestRoute,
        request: request,
        requestParams: requestParams,
    });
};
exports.checkAccessStatusDefaultStrategy = {
    execute: execute,
};
